import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { getAppConfig } from "../components/services/appConfigService";

let s3Client = null;
let awsConfigCache = null;

const getAwsConfig = async () => {
  if (awsConfigCache) {
    return awsConfigCache;
  }

  const configResponse = await getAppConfig();
  const awsConfig = configResponse?.aws;

  if (
    !awsConfig?.region ||
    !awsConfig?.accessKey ||
    !awsConfig?.secretAccessKey ||
    !awsConfig?.bucket
  ) {
    throw new Error("AWS configuration is missing from backend response.");
  }

  awsConfigCache = awsConfig;
  return awsConfigCache;
};

const getS3Client = async () => {
  if (s3Client) {
    return s3Client;
  }

  const awsConfig = await getAwsConfig();
  s3Client = new S3Client({
    region: awsConfig.region,
    credentials: {
      accessKeyId: awsConfig.accessKey,
      secretAccessKey: awsConfig.secretAccessKey,
    },
  });

  return s3Client;
};

/**
 * Upload a file to S3 and return the public URL.
 * @param {File} file - File to upload
 * @param {string} folder - Optional folder path in S3
 * @returns {Promise<string>} - Public URL of uploaded file
 */
export const uploadToS3 = async (file, folder = "temp") => {
  if (!file) return null;
  const awsConfig = await getAwsConfig();
  const client = await getS3Client();
  const fileKey = `${folder}/${Date.now()}_${file.name}`;
  const params = {
    Bucket: awsConfig.bucket,
    Key: fileKey,
    Body: await file.arrayBuffer(),
    ContentType: file.type,
    ACL: "public-read",
  };

  try {
    const command = new PutObjectCommand(params);
    await client.send(command);
    return `https://${awsConfig.bucket}.s3.${awsConfig.region}.amazonaws.com/${fileKey}`;
  } catch (error) {
    console.error("S3 Upload Error:", error);
    throw new Error("Failed to upload file to S3.");
  }
};
